import type { Props } from 'react-joyride';

export const TOUR_Z_INDEX = 10_000;

export const beaconStyles: Props['styles'] = {
  overlay: { backgroundColor: 'rgba(4, 5, 7, 0.72)', mixBlendMode: 'normal' },
  spotlight: {
    stroke: 'var(--color-primary-9)',
    strokeWidth: 1.5,
  },
};

export const beaconOptions: Props['options'] = {
  zIndex: TOUR_Z_INDEX,
  overlayClickAction: false,
  closeButtonAction: 'skip',
  skipBeacon: true,
  spotlightPadding: 6,
  spotlightRadius: 10,
  targetWaitTimeout: 5_000,
};
